export default {
  //PC网址
  GLOBAL_WWW_URL: "https://www.yojiameng.com",
  //M网址
  GLOBAL_M_URL: "https://m.yojiameng.com",
  // 开发环境，接口地址
  GLOBAL_API_URL: "https://api.yojiameng.com",
  // www 接口
  WWW_API_URL: "https://api.yojiameng.com",
  // // 用户环境
  USER_API_URL: 'https://api.yojiameng.com',
  // 测试环境，接口地址
  // TEST_API_URL: 'http://xlhwebapi.xlhbank.com',
  // 正式环境，接口地址
  PROD_API_URL: '',
  // 接口日志，开启后将打印接口信息
  LOG_API: false
}

// export const upload = {
//   // 上传限制大小
//   size: '2048',
//   // 上传扩展名
//   ext: 'gif,jpg,jpeg,bmp,png',
//   // 是否上传到 oss
//   oss: 'open',
//   // 缩略图
//   thumb: '300'
// }



//////////////////
// WEBPACK FOOTER
// ./config/config.base.js
// module id = 5aMX
// module chunks = 19